<template>
  <div class="menu">
    <el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
      :default-openeds="['1', '2']" :collapse="isCollapse" router>
      <el-menu-item index="/home"><i class="el-icon-s-home" /><span slot="title">首页</span></el-menu-item>

      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-menu"></i>
          <span>招标信息</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="/pm"><span slot="title">招标信息</span></el-menu-item>
          <el-menu-item index="/participant"><span slot="title">我参与的</span></el-menu-item>
          <!-- <el-menu-item index="/finished"><span slot="title">已结束</span></el-menu-item> -->
        </el-menu-item-group>

      </el-submenu>


      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-s-custom"></i>
          <span>我的</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="/my"><span slot="title">我的</span></el-menu-item>
          <el-menu-item index="/edit"><span slot="title">编辑</span></el-menu-item>
        </el-menu-item-group>

      </el-submenu>






    </el-menu>
  </div>
</template>

<script>
export default {
  props: ['isCollapse'],
  data() {
    return {
      path: '/home',
    }
  },
  methods: {
    handleClose() {

    },
    handleOpen() {

    }

  }

}
</script>

<style>
.menu {
  width: 200px;
  height: calc(100vh - 58px);
  margin-top: 2px;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/LayOut/LeftMenu.vue